export const GETMYSHEETS = "GETMYSHEETS"
export const GETALLSHEETS = "GETALLSHEETS"
export const UPDATE_SHEET_INFO ="UPDATE_SHEET_INFO"